export interface CursorPaginationParams {
  limit?: number;
  cursor?: string;
}

export interface OffsetPaginationParams {
  limit?: number | undefined;
  offset?: number | undefined;
}

export interface PaginatedResponse<T> {
  data: T[];
  nextCursor?: string;
  hasMore?: boolean;
}

export function buildCursorParams(params: CursorPaginationParams): Record<string, string> {
  const query: Record<string, string> = {};

  if (params.limit !== undefined) {
    query.limit = params.limit.toString();
  }

  if (params.cursor) {
    query.cursor = params.cursor;
  }

  return query;
}

export function buildOffsetParams(
  params: OffsetPaginationParams & Record<string, unknown>
): Record<string, string> {
  const query: Record<string, string> = {};

  // Handle all properties in params
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }

    // Handle arrays
    if (Array.isArray(value)) {
      query[key] = value.join(',');
      continue;
    }

    // Handle booleans
    if (typeof value === 'boolean') {
      query[key] = value.toString();
      continue;
    }

    // Handle numbers
    if (typeof value === 'number') {
      query[key] = value.toString();
      continue;
    }

    // Handle strings
    if (typeof value === 'string') {
      query[key] = value;
      continue;
    }

    // Handle objects (convert to string)
    if (typeof value === 'object') {
      query[key] = JSON.stringify(value);
      continue;
    }

    // Fallback to string conversion
    query[key] = String(value);
  }

  return query;
}
